import React from 'react';

const PhoneMockup = ({
  children,
  className = '',
  size = 'md',
  glow = true,
  rotate = 0,
  scale = 1,
  /** Lighter treatment: no heavy black drop shadow; silver rim matches full chrome. */
  minimalChrome = false,
}) => {
  const sizes = {
    sm: { width: 220, height: 444 },
    md: { width: 260, height: 520 },
    lg: { width: 300, height: 600 },
    xl: { width: 340, height: 680 },
  };

  const { width, height } = sizes[size] || sizes.md;

  return (
    <div
      className={`relative ${className}`}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        transform: `rotate(${rotate}deg) scale(${scale})`,
        transformOrigin: 'center center',
      }}
    >
      {/* Ambient glow behind phone */}
      {glow && (
        <div
          style={{
            position: 'absolute',
            inset: '-20px',
            borderRadius: '60px',
            background: 'radial-gradient(ellipse at center, rgba(212,175,55,0.1) 0%, transparent 70%)',
            filter: 'blur(30px)',
            zIndex: 0,
            pointerEvents: 'none',
          }}
        />
      )}

      {/* Phone frame */}
      <div
        style={{
          position: 'relative',
          width: `${width}px`,
          height: `${height}px`,
          background: '#0A0A0A',
          borderRadius: '40px',
          /* Silver rim — same on hero and minimalChrome; heavy outer shadow only when not minimal. */
          border: '2px solid rgba(255,255,255,0.12)',
          boxShadow: minimalChrome
            ? 'inset 0 1px 0 rgba(255,255,255,0.07), inset 0 -1px 0 rgba(0,0,0,0.5)'
            : '0 60px 120px rgba(0,0,0,0.9), inset 0 1px 0 rgba(255,255,255,0.08), inset 0 -1px 0 rgba(0,0,0,0.5)',
          overflow: 'hidden',
          zIndex: 1,
        }}
      >
        {/* Dynamic Island */}
        <div
          style={{
            position: 'absolute',
            top: '14px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: `${width * 0.33}px`,
            height: '24px',
            background: '#000',
            borderRadius: '20px',
            zIndex: 20,
          }}
        />

        {/* Status bar */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '48px 20px 0',
            fontSize: '11px',
            color: '#F5F1EA',
            fontWeight: '600',
            zIndex: 10,
            fontFamily: 'Inter, sans-serif',
            height: '70px',
          }}
        >
          <span>9:41</span>
          <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
            {/* Signal bars */}
            <svg width="14" height="10" viewBox="0 0 14 10" fill="none">
              <rect x="0" y="6" width="2.5" height="4" rx="0.5" fill="#F5F1EA"/>
              <rect x="3.5" y="4" width="2.5" height="6" rx="0.5" fill="#F5F1EA"/>
              <rect x="7" y="2" width="2.5" height="8" rx="0.5" fill="#F5F1EA"/>
              <rect x="10.5" y="0" width="2.5" height="10" rx="0.5" fill="#F5F1EA"/>
            </svg>
            {/* Battery */}
            <svg width="20" height="11" viewBox="0 0 20 11" fill="none">
              <rect x="0" y="1" width="17" height="9" rx="2" stroke="#F5F1EA" strokeWidth="1.2"/>
              <rect x="1" y="2" width="13" height="7" rx="1" fill="#F5F1EA"/>
              <path d="M18 4v3a1.5 1.5 0 000-3z" fill="#F5F1EA"/>
            </svg>
          </div>
        </div>

        {/* Screen content */}
        <div
          style={{
            position: 'absolute',
            top: '70px',
            left: 0,
            right: 0,
            bottom: '28px',
            overflow: 'hidden',
            background: '#0F0F0F',
          }}
        >
          {children}
        </div>

        {/* Home indicator */}
        <div
          style={{
            position: 'absolute',
            bottom: '8px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: `${width * 0.44}px`,
            height: '4px',
            background: 'rgba(255,255,255,0.25)',
            borderRadius: '2px',
          }}
        />
      </div>
    </div>
  );
};

export default PhoneMockup;
